import { useDispatch, useSelector } from 'react-redux';

import { Cobrander } from 'app/model/cobrander';
import { AppDispatch } from 'app/store';
import { loadCobranders, selectCobranders } from 'features/core/core.slice';

let loadRequested = false;
export const useCobranders = (): { loaded: boolean; cobranders: Cobrander[] } => {
    const cobranders = useSelector(selectCobranders);
    const dispatch = useDispatch<AppDispatch>();

    const loaded = undefined !== cobranders;

    if (!loaded && !loadRequested) {
        dispatch(loadCobranders()).subscribe();
        loadRequested = true;
    }

    return { loaded, cobranders: cobranders || [] };
};
